var styles = [".title[_ngcontent-%COMP%]{color:#424850}a[_ngcontent-%COMP%]{font-size:16px;line-height:36px;font-weight:300;padding:0 28px}@media (max-width:1199.98px){a[_ngcontent-%COMP%]{padding:0 23px}}@media (max-width:767.98px){a[_ngcontent-%COMP%]{padding:0 6px}}"];
export { styles as styles };
